export function formatInitialValue(value: number | null): string {
    if (value === null) {
        return '';
    }

    return `${value}`;
}

export function formatValue(value: string): number | null {
    const formattedValue = parseInt(value);

    if (isNaN(formattedValue)) {
        return null;
    }

    return formattedValue;
}
